import _ from 'lodash';


export const getAuthHeader = ()=>{
    const token = localStorage.getItem('jwt_token'); // Retrieve the JWT token from local storage
    if (token) {
        return {
            'Authorization': `Bearer ${token}`
        }
    }
}


export const prepareJsonPayload = ({data, method='POST'})=>{
    let payload = {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...getAuthHeader()
        },
    }
    if (!['GET', 'HEAD'].includes(method?.toUpperCase())) {
        payload.body = JSON.stringify(data);
    }
    return payload;
}

/**
 *  Get values from state by paths
 * @param state {redux.State}
 * @param paths {string[]|string}
 * @returns {*}
 *
 * */
export const getValuesByPaths = (state, paths) => {
  if (Array.isArray(paths)) {
    return paths.reduce((acc, path) => {
      acc[path] = _.get(state, path);
      return acc;
    }, {});
  } else {
    return _.get(state, paths);
  }
};